export const underfloorContent = [
  {
    heroTitle: "Benefit From Underfoor Heating",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "We're specialist underfloor heating installers",
    introText: `From existing homes to new builds, many are turning to the efficiency of underfloor heating. Our specialist engineers install wet underfloor heating in Leeds and beyond`,
  },
  {
    contLeftTitle: "Clear Up Space For Design",
    contLeftText: `Radiators take up space in a room, whereas underfloor heating is out of sight and provides much more freedom to decorate.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643105461/AquaHeat/new%20images/modern-kitchen_ddiou6.webp`,
  },
  {
    contRightTitle: "Roth Systems Approved Installer",
    contRightText: `Whether it's for a new build home, or a home improvement project, we can provide a comprehensive underfloor heating installation.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643105298/AquaHeat/new%20images/Screenshot_2022-01-25_at_10.04.28_czzcia.webp`,
  },
  {
    callToActionTitle: "Talk To Us Today. Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
